import { Box, Typography } from "@mui/material";
import MapComponent from "../general/MapComponent";
import { useAppSelector } from "store/appHooks";

const ListingLocation = () => {
  const { listingDetails }: any = useAppSelector(
    (state) => state.searchListingReducer
  );
  const address = listingDetails?.user?.listing_address?.[0] ?? null;
  return (
    <Box sx={{ px: "2%", my: "20px" }}>
      <Typography
        sx={{
          fontSize: "40px",
          fontWeight: 600,
          lineHeight: "52px",
          color: "#323232",
          mb: "25px",
        }}
      >
        Location
      </Typography>

      {address && (
        <MapComponent
          marks={[
            { lat: address?.latitude ?? 0, lng: address?.longitude ?? 0 },
          ]}
          onClick={null}
          height="50vh"
          showTopGradiant={false}
        />
      )}

      {address && (
        <Box sx={{ mt: "15px" }}>
          <Typography
            sx={{
              color: "#323232",
              fontSize: "18px",
              lineHeight: "26px",
              fontWeight: 600,
            }}
          >
            {address.address_line_1}
          </Typography>
          <Typography
            sx={{
              color: "#A2A2A2",
              fontSize: "16px",
              lineHeight: "26px",
              fontWeight: 400,
            }}
          >
            Exact location provided after booking
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ListingLocation;
